// utils.js

export const loadImageSafely = (src) => {
  return new Promise((resolve, reject) => {
    const img = new Image();

    // Set a timeout for image loading
    const timeout = setTimeout(() => {
      img.onload = null;
      img.onerror = null;
      reject(new Error(`Image loading timeout for: ${src?.substring(0, 50)}...`));
    }, 10000); // 10-second timeout

    img.onload = () => {
      clearTimeout(timeout);
      resolve(img);
    };

    img.onerror = (error) => {
      clearTimeout(timeout);
      console.error('Image loading failed:', error);
      reject(new Error(`Failed to load image: ${src?.substring(0, 50)}...`));
    };

    // Validate src before setting
    if (!src || typeof src !== 'string') {
      clearTimeout(timeout);
      reject(new Error('Invalid image source provided'));
      return;
    }

    img.src = src;
  });
};
